import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const MiniGantt = ({ className = '', locked = false }) => {
  const W = 130, H = 48, pad = 6;
  const rows = [10, 22, 34];
  const bars = [
    { x: 12, w: 56, y: rows[0], c: 'rgba(16,185,129,0.85)' },
    { x: 22, w: 72, y: rows[1], c: 'rgba(84,137,182,0.85)' },
    { x: 8,  w: 36, y: rows[2], c: 'rgba(100,116,139,0.85)' },
  ];
  return (
    <svg className={className} viewBox={`0 0 ${W} ${H}`} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="0" y="0" width={W} height={H} rx="6" fill="none" />
      <line x1={pad} y1={H - pad} x2={W - pad} y2={H - pad} stroke="currentColor" opacity="0.15" />
      {[0,1,2,3,4].map(i => (
        <line key={i} x1={pad + i*((W-2*pad)/4)} y1={H - pad} x2={pad + i*((W-2*pad)/4)} y2={H - pad - 4} stroke="currentColor" opacity="0.15" />
      ))}
      {bars.map((b, i) => (
        <rect key={i} x={b.x} y={b.y} width={b.w} height="8" rx="4" fill={b.c} opacity={locked ? 0.6 : 1} />
      ))}
    </svg>
  );
};

const ActionPlanCtaTile = ({ state = 'locked', onClick }) => {
  const intl = useIntl();
  useEffect(() => { try { if (window.ahoy?.track) window.ahoy.track('action_plan_tile_viewed', { state }); } catch(_) {} }, [state]);
  const locked = state === 'locked';
  const badge = locked ? '🔒' : intl.formatMessage({ id: 'succession.action_plan_cta_tile.view_plan_badge' });
  const badgeClass = locked ? 'bg-gray-100 text-gray-600' : 'bg-blue-50 text-blue-700';

  return (
    <button
      onClick={() => { try { if (window.ahoy?.track) window.ahoy.track('action_plan_tile_clicked', { state }); } catch(_) {}; if (onClick) onClick(); }}
      className="group w-full text-left"
      aria-label={locked ? intl.formatMessage({ id: 'succession.action_plan_cta_tile.aria_label_locked' }) : intl.formatMessage({ id: 'succession.action_plan_cta_tile.aria_label_unlocked' })}
    >
      <div className="rounded-2xl border border-succession-border bg-white p-4 shadow-sm hover:shadow-md transition transform hover:scale-105 flex flex-col h-full">
        <div className="flex items-start">
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between">
              <div className="text-lg font-medium text-succession-text-primary"><FormattedMessage id="succession.action_plan_cta_tile.title" /></div>
              <span className={`text-[10px] px-2 py-0.5 rounded-full ${badgeClass}`}>{badge}</span>
            </div>
            <div className="text-xs text-succession-text-secondary mt-0.5">
              {locked ? <FormattedMessage id="succession.action_plan_cta_tile.subtitle_locked" /> : <FormattedMessage id="succession.action_plan_cta_tile.subtitle_unlocked" />}
            </div>

            <div className="mt-4 flex items-center justify-center py-2">
              <MiniGantt className="h-16 w-40" locked={locked} />
            </div>

            <div className="mt-3 flex items-center justify-between">
              <span className="text-[11px] text-succession-text-secondary">
                {locked ? <FormattedMessage id="succession.action_plan_cta_tile.footer_locked" /> : <FormattedMessage id="succession.action_plan_cta_tile.footer_unlocked" />}
              </span>
              <span className="text-xs font-medium text-emerald-700 group-hover:underline">
                <FormattedMessage id="succession.action_plan_cta_tile.open" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
};

export default ActionPlanCtaTile;


